<template>
  <div ref="tableContainer">
    <div style="clear:both">
      <el-select
        v-model="selectedCultureID"
        class="search-select"
        type="select"
        style="float:left;margin-bottom:10px"
        :placeholder="$t('priceListItem.laborPrice')"
        clearable
        @change="handleFilterChange"
      >
        <el-option v-for="culture in cultures" :key="culture.id" :label="culture.description" :value="culture.id" />
      </el-select>
      <date-picker
        v-model="validDate"
        :show-week-numbers="false"
        :placeholder="$t('common.date')"
        style="float:left;margin-left:10px"
        class="search-select"
        @input="handleFilterChange"
      />
    </div>
    <el-table
      id="crudPriceListItems"
      ref="crudPriceListItems"
      :data="transformedItems"
      border
      fit
      style="width: 100%"
      :max-height="getMaxTableHeight()"
    >
      <el-table-column>
        <el-table-column :label="$t('priceListItem.height')">
          <template slot-scope="scope">
            <span>{{ scope.row.height }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column v-for="(width, i) in widths" :key="width" :label="i === 0 ? $t('priceListItem.width') : ''">
        <el-table-column :label="width">
          <template slot-scope="scope">
            <span>{{ scope.row[width].price }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DatePicker from '@/components/DSE/DatePicker';
import { PriceTypeOption } from '@/utils/constants';
import { toDateString } from '@/utils/date';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      items: [],
      selectedCultureID: null,
      transformedItems: [],
      validDate: toDateString(new Date()),
      widths: []
    };
  },
  computed: {
    cultures() {
      return this.$store.getters['culture/loadedItems'];
    },
    listParams() {
      const cultureID = this.selectedCultureID;
      const priceTypeOption = cultureID ? PriceTypeOption.ConsumerPrice : PriceTypeOption.SellingPrice;
      return {
        priceListItemID: this.priceListItemID,
        priceTypeOption: priceTypeOption,
        cultureID: cultureID,
        validDate: this.validDate
      };
    },
    priceListItemID() {
      return +this.$route.params.id;
    }
  },
  created() {
    this.refreshList();
  },
  methods: {
    createMatrix() {
      this.setWidths();
      this.transformLengthsIntoRows();
    },
    getMaxTableHeight() {
      if (this.$refs.tableContainer) {
        const spaceForButtons = 150;
        return window.innerHeight - this.$refs.tableContainer.getBoundingClientRect().top - spaceForButtons;
      }
    },
    handleFilterChange() {
      this.refreshList();
    },
    setWidths() {
      let itemsSortedBywidth = [...this.items];
      itemsSortedBywidth = itemsSortedBywidth.sort((a, b) => {
        return a.widthInCm - b.widthInCm;
      });
      this.widths = [...new Set(itemsSortedBywidth.map(i => i.widthInCm.toString()))];
    },
    refreshList() {
      this.loading = true;
      this.$store
        .dispatch('priceListItem/getPriceMatrix', this.listParams)
        .then(data => {
          this.items = data.items;
          this.createMatrix();
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    transformLengthsIntoRows() {
      const transformedItems = {};
      this.items.forEach(i => {
        if (!transformedItems[i.heightInCm]) {
          transformedItems[i.heightInCm] = { height: i.heightInCm };
        }
        transformedItems[i.heightInCm][i.widthInCm] = {
          price: i.price
        };
      });
      this.transformedItems = Object.entries(transformedItems).map(x => x[1]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
